import {Component, EventEmitter, Input, OnChanges, OnInit, Output, OnDestroy, ViewChildren} from '@angular/core';
import {Subject} from "rxjs";
import {debounceTime} from "rxjs/operators";
import {WhiteTooltipDirective} from '../../directives/whiteTooltip/white-tooltip.directive';

declare var Yiit;

@Component({
  selector: 'app-opacity-slider',
  templateUrl: './opacity-slider.component.html',
  styleUrls: ['./opacity-slider.component.scss']
})
export class OpacitySliderComponent implements OnInit, OnChanges, OnDestroy {

  @Input() currentOpacity;
  @Output() emitter = new EventEmitter<number>();
  @Input() item;

  opacity$ = new Subject();
  public Yiit = Yiit;
  @ViewChildren(WhiteTooltipDirective) tooltips;

  private _isDisabled = null;

  get isDefaultValue(): boolean {
    if (this.item && this.currentOpacity) {
      return this.currentOpacity === this.getDefaultOpacity();
    }
    return true;
  }

  @Input()
  set disabled(val: any) {
    this._isDisabled = val ? 'disabled' : null;
  }

  get disabled(): any {
    return this._isDisabled;
  }

  constructor() {
    this.opacity$
      .pipe(debounceTime(300))
      .subscribe((val: number) => {
        this.emitter.emit(val);
      });
  }

  ngOnInit(): void {
    if (!this.currentOpacity){
      this.setOpacity(0, true);
    }
  }

  ngOnChanges(changes): void {
    // console.log('currentOpacity', this.currentOpacity);
  }

  ngOnDestroy() {
    this.tooltips.forEach((item) => {
      item.hide();
    });
  }

  setOpacity(value: any, isSilent?) {
    let _value = parseFloat(value);
    if (isNaN(_value)) {
      _value = 0;
    }
    if (_value > 100) {
      _value = 100;
    }
    if (_value < 0) {
      _value = 0;
    }
    this.currentOpacity = _value;
    let opacity = parseFloat((_value / 100).toFixed(2));
    if (!isSilent) {
      this.opacity$.next(opacity);
    }
  }

  resetToDefault() {
    if (!this.isDefaultValue) {
      this.setOpacity(this.getDefaultOpacity(), false);
    }
  }

  private getDefaultOpacity() {
    if (this.item) {
      return this.item.config.getTool().default_opacity * 100;
    }
    return 100;
  }
}
